import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { EventType, Router, RouterLinkActive, RouterLink } from "@angular/router";
import { AuthService } from "../../core/services/auth.service";
import { permissionType } from "src/app/models/enums";
import { UserIdleService } from "wspowerpack";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import { Subscription, filter, interval } from "rxjs";
import { AccountClient, AccountV1Model } from "../../../api/client";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  standalone: true,
  imports: [RouterLinkActive, RouterLink, NgIf],
})
export class NavbarComponent implements OnInit {
  @ViewChild("timeout", { static: true }) timeoutDialog!: TemplateRef<any>;
  showMobileMenu: boolean = false;
  dialogRef: NgbModalRef | null = null;
  count: number = 30;
  isAdmin: boolean = false;
  isGlobal: boolean = false;
  isAuth: boolean = false;
  welcome: string | null = null;
  isReady: boolean = false; //this is just to hide features we are not ready for and should be removed eventually
  currentAccount: AccountV1Model = new AccountV1Model();
  isLoading: boolean = true;
  apiRoot: string = environment.apiRoot;
  guid: string | null | undefined = "act";
  accountChanged: Subscription | null = null;
  isInitialized: boolean = false;

  constructor(
    private userIdle: UserIdleService,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private accountClient: AccountClient
  ) {
    this.guid = this.authService.getCurrentGuid();

    this.isAdmin = this.authService.hasPermission(permissionType.Users);
    this.isGlobal = this.authService.hasPermission(permissionType.CreateAccounts);
  }

  // helper function to determine if the active class should be added to the administration dropdown link
  addActiveClassToAdminDropdown(): boolean {
    let url = this.router.url;
    //if it has administration in it return true
    if (url.indexOf("admin") != -1) {
      return true;
    } else {
      //otherwise return false to not add active class
      return false;
    }
  }

  addActiveClassToLibraryDropdown(): boolean {
    let url = this.router.url;
    //if it has library in it return true
    if (url.indexOf("library/procedures") != -1) {
      return false;
    } else if (url.indexOf("library") != -1) {
      return true;
    } else {
      //otherwise return false to not add active class
      return false;
    }
  }

  ngOnInit(): void {
    this.isAuth = this.authService.isLoggedIn();

    this.welcome = this.authService.getUserDisplayName();

    this.authService.isLoggedIn$.subscribe((l) => {
      this.welcome = this.authService.getUserDisplayName();
      if (l && !this.isInitialized) {
        this.isInitialized = true;
        this.setIdle();
        this.loadCurrentAccount(this.authService.user.currentAccountId);
      } else {
        this.stop();
        this.stopWatching();
      }
    });

    this.accountChanged = this.authService.accountChange$.subscribe((accountId) => {
      this.loadCurrentAccount(accountId);
    });

    this.authService.renew(); //renew on first refresh and then every 5 minutes
  }

  onSignout(): void {
    this.authService.logout();
  }

  onShowMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
  }

  loadCurrentAccount(accountId: number | 0): void {
    if (accountId == 0) return;
    this.accountClient.getById(accountId).subscribe((data) => {
      this.currentAccount = data;
      this.guid = data.accountCode;
      this.isLoading = false;
    });
  }

  //*********** IDLE TIMEOUT //***********
  setIdle(): any {
    console.log("Setup Idle");
    //Start watching for user inactivity.
    this.userIdle.startWatching();
    this.userIdle.resetTimer();
    //Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {
      this.count = 30 - count;
      if (this.dialogRef == null && count != null && count < 30) {
        this.dialogRef = this.modalService.open(this.timeoutDialog, {
          backdrop: "static",
        });
      }
      if (count == 30) {
        if (this.dialogRef != null) this.dialogRef.close("");
      }
    });
    // dialogRef.afterClosed().subscribe(result => {
    //  this.setupLogDS();
    // });

    //Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      console.log("Time is up!");
      if (this.dialogRef != null) this.dialogRef.close("");
      this.authService.logout();
      this.stop();
      this.stopWatching();
      this.dialogRef = null;
    });

    //Ping
    this.userIdle.ping$.subscribe(() => {
      console.log("Idle! " + new Date().toLocaleTimeString());
      if (this.authService.isLoggedIn()) {
        this.authService.renew();
      }
    });
  }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }

  onContinue() {
    this.dialogRef?.close("");
    this.restart();
    this.startWatching();
    this.setIdle();
    this.dialogRef = null;
  }

  onManualLogout() {
    this.dialogRef?.close();
    this.authService.logout();
    this.stop();
    this.stopWatching();
    this.dialogRef = null;
  }
}
